import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaLinkedin,
} from "react-icons/fa";

function Contact_Popup() {
  return (
    <div className="py-6 px-4 w-full">
      <div className="bg-white rounded-md shadow-sm overflow-hidden">

        {/* Header Section */}
        <div className="px-6 py-4 flex items-center justify-between border-b border-gray-200">
          <h1 className="text-xl font-semibold text-gray-900">
            Akshat Srivastava
          </h1>
        </div>

        {/* Sub Header */}
        <div className="px-6 py-4 pb-2">
          <h2 className="text-xl font-medium text-gray-900 mb-1">Contact Info</h2>
        </div>

        {/* Contact Information */}
        <div className="px-6 pb-8 pt-2 space-y-7">

          {/* LinkedIn */}
          <div className="flex items-start">
            <div className="mt-1 text-gray-500 mr-4 opacity-80">
              <FaLinkedin size={22} />
            </div>
            <div>
              <h3 className="text-[15px] font-semibold text-gray-900">Your Profile</h3>
              <a
                href="https://www.linkedin.com/in/akshatsrivastava/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[15px] text-[#0a66c2] hover:underline font-semibold tracking-wide"
              >
                linkedin.com/in/akshatsrivastava
              </a>
            </div>
          </div>

          {/* Email */}
          <div className="flex items-start">
            <div className="mt-1 text-gray-500 mr-4 opacity-80">
              <FaEnvelope size={22} />
            </div>
            <div>
              <h3 className="text-[15px] font-semibold text-gray-900">Email</h3>
              <a
                href="mailto:akshatsrivastava566@gmail.com"
                className="text-[15px] text-[#0a66c2] hover:underline font-semibold tracking-wide"
              >
                akshatsrivastava566@gmail.com
              </a>
            </div>
          </div>

          {/* Phone */}
          <div className="flex items-start">
            <div className="mt-1 text-gray-500 mr-4 opacity-80">
              <FaPhoneAlt size={20} />
            </div>
            <div>
              <h3 className="text-[15px] font-semibold text-gray-900">Phone</h3>
              <p className="text-[15px] text-gray-700">
                (+91) 8181864070 <span className="text-gray-500 font-normal ml-1">(Mobile)</span>
              </p>
            </div>
          </div>

          {/* Address */}
          <div className="flex items-start">
            <div className="mt-1 text-gray-500 mr-4 opacity-80">
              <FaMapMarkerAlt size={22} />
            </div>
            <div>
              <h3 className="text-[15px] font-semibold text-gray-900">Address</h3>
              <p className="text-[15px] text-gray-700 mb-1">
                Gurugram, Haryana, India (Current)
              </p>
              <p className="text-[15px] text-gray-700">
                Prayagraj, UP, India (Permanent)
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Contact_Popup;
